// extracted by mini-css-extract-plugin
export default {"home":"style_home__olWZl","body":"style_body__j-k-2","rightSidebar":"style_rightSidebar__KwANx"};